module.exports = __webpack_public_path__ + "static/media/icon_204.9134b5bb.svg";